import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import {
  CircularProgress,
  FormControl,
  Grid,
  TextField,
} from '@material-ui/core';
import round from 'helpers/mathRound';
import { calculateSavings } from 'pages/quotes/helpers';


const QuoteItemUnitPrice = ({
  item,
  index,
  formik,
  selectedDataSource,
  product
}) => {
  const [loading, setLoading] = useState(false);

  const {
    selectedItemGroup,
    sku,
    fixedPrice,
    subscription_id,
    discount,
    discountType,
    qty
  } = item;

  const {
    handleChange,
    handleBlur,
    touched,
    errors,
    setFieldValue
  } = formik;

  const {
    productAttributes,
    subscriptionOptions,
  } = selectedDataSource;

  const savings = +productAttributes?.savings || 0;
  const isSubscriptionActive = parseInt(productAttributes.subscription_active) === 1;
  const productPrice = product?.price || 0;
  const isAlleSKU = sku?.includes('bdsku');

  const {
    installment_price: initialInstallmentPrice = 0,
    adjustment_price: initialAdjustmentPrice = 0
  } = subscriptionOptions?.find(
    (option) => option.id === Number(subscription_id)
  ) || {
    installment_price: 0,
    adjustment_price: 0
  };

  let newPrice;

  if (fixedPrice !== productPrice) {
    newPrice = fixedPrice;
  } else if (isSubscriptionActive && (initialInstallmentPrice || initialAdjustmentPrice)) {
    newPrice = round(initialInstallmentPrice + initialAdjustmentPrice) + savings;
  } else {
    newPrice = productPrice + savings;
  }

  useEffect(() => {
    if (sku) {
      setLoading(true);
      setFieldValue(`items[${index}].fixedPrice`, newPrice);
      setLoading(false);
    }
  }, [sku]);

  const handleFixedPriceChange = (event) => {
    handleChange(event);
    const { value } = event.target;
    const parsedNumericValue = parseFloat(value.replace(/[^0-9.]/g, ''));

    const updatedValues = {
      fixedPrice: parsedNumericValue,
      savings: calculateSavings(discountType, discount, parsedNumericValue, savings, qty),
    };

    setFieldValue(`items[${index}]`, { ...item, ...updatedValues });
  };

  return (
    <Grid item xs={12} lg>
      {(loading) ? (
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <CircularProgress color="inherit" size={40} />
          </Grid>
        </Grid>
      ) : (
        <FormControl variant="outlined" fullWidth>
          <NumberFormat
            customInput={TextField}
            name={`items[${index}].fixedPrice`}
            label="Unit Price"
            prefix="$"
            fixedDecimalScale
            disabled={!selectedItemGroup || !sku || isAlleSKU}
            decimalScale={2}
            thousandSeparator
            fullWidth
            variant="outlined"
            value={`$ ${round(fixedPrice)}`}
            onChange={handleFixedPriceChange}
            onBlur={handleBlur}
            error={touched.items?.[index]?.fixedPrice && !!errors.items?.[index]?.fixedPrice}
            helperText={touched.items?.[index]?.fixedPrice && errors.items?.[index]?.fixedPrice}
          />
        </FormControl>
      )}
    </Grid>
  );
};

export default QuoteItemUnitPrice;
